<app-header *ngIf="showNav"></app-header>
<app-nav *ngIf="showNav" [servicesTitle]="(navTitle$ | async) ?? ''"></app-nav>

<div class="page-wrapper">
  <!-- <app-chatbot></app-chatbot> -->

  <div [@routerTransition]="getState(outlet)" class="page-content">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>

  <app-footer [customFooter]="footerClass"></app-footer>
</div>

<app-end-session-notification></app-end-session-notification>
<app-loading></app-loading>